export default {"src":"/_next/static/media/clock-edit.bc55ba53.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};